import {
    StyledWhy,
    CardWrapper,
    FirstCardItem,
    SecondCardItem,
    ThirdCardItem,
    CardHeading,
    CardBottom,
    CardText,
    BlackCardText,
} from "./styles/StyledWhy";
import { useTranslation } from 'react-i18next';
import InstagramIcon from '@mui/icons-material/Instagram';

const WhyRest = () => {
    const { t, i18n } = useTranslation();

    return (
        <div>
            <StyledWhy>
                <h2>Blockchain Marriage — A New Romantic Tradition</h2>
                <span>
                    Now your restaurant can offer more than just a dinner or celebration — it can create a unique and unforgettable moment for guests: the chance to immortalize their love through blockchain technology.<br/>
                    Couples celebrating anniversaries, weddings, or simply a special evening will not only enjoy premium service but also the opportunity to preserve the memory forever in digital eternity — choosing your restaurant to do it.
                </span>
            </StyledWhy>
            <StyledWhy>
                <h2>Your Venue Becomes a Digital Wedding Hall  </h2>
                <p>We invite you to become the exclusive Web3Wed partner venue in your city.</p>
                <span>
                    - Exclusive partner status for 1 year  <br/>
                    - 3-month trial period with no obligations  <br/>
                    - Flexible use — couples can register their marriage on the spot or later, in a comfortable setting
                </span>
            </StyledWhy>
            <StyledWhy>
                <h2>How does the registration work?  </h2>
                <p>We do not store guest data, do not access their video, and cannot alter or delete anything.</p>
                <span>
                     Guests scan a QR code and access Web3Wed.io via trusted login options (Google, Meta, etc.).  <br/>
                    - The registration is automated — no personal data is shared with the platform  <br/>
                    - The couple records a video vow, which is instantly published on the blockchain and decentralized platforms
                </span>
                <p>Thanks to blockchain, everything is secure and immutable — making the process transparent and trustworthy.</p>
            </StyledWhy>
            <StyledWhy>
                <h2>How does it work for your restaurant?  </h2>
                <p>You become the only restaurant in your city offering this service.</p>
                <span>
                    - Guests register their blockchain marriage for free using your promo code  <br/>
                    - You set your own price for the service — including your hospitality offering  <br/>
                    - Promo codes are provided to you free of charge as part of the marketing partnership
                </span>
            </StyledWhy>
            <StyledWhy>
                <h2>Web3Wed Promotion Agreement</h2>
                <p>Our Dubai office signs an agreement with you to promote Web3Wed.io in your city.</p>
                <span>
                    - Promo codes are issued to your restaurant at no cost and used to market the service  <br/>
                    - You agree to reinvest a portion of the revenue into promoting the service  <br/>
                    - Budget split:<br/>
                      - 50% for promoting Web3Wed in your city  <br/>
                      - 50% for promoting the service within your restaurant.<br/>
                    - We estimate a reinvestment amount of approx. $50 (since the standard retail price of the service is $111)  <br/>
                    - The funds remain in your account, but our team manages the marketing decisions  <br/>
                    - Your marketing department executes the promotions — with a focus on SMM and digital campaigns


                </span>
                <p>This partnership format brings in new customers and increases the visibility of both your restaurant and the Web3Wed service.</p>
            </StyledWhy>
            <StyledWhy>
                <h2>What Your Restaurant Gains?</h2>
                <span>
                    - A unique service — your restaurant becomes a venue where couples form digital unions  <br/>
                    - Added value for guests — couples choose your space for their most meaningful occasions  <br/>
                    - New revenue stream — monetize the experience with no upfront investment  <br/>
                    - Exclusive right to branded certificates — you’ll have unique, custom-designed digital assets  <br/>
                    - Organic marketing — guests share their stories, spreading awareness naturally  <br/>
                    - Expanded cooperation with wedding planners — the new service helps attract more couples<br/>

                </span>
            </StyledWhy>
            <StyledWhy>
                <h2>Try It Risk-Free  </h2>
                <p>You receive exclusive Web3Wed partner status in your city, with the first 3 months as a trial period.</p>
                <span>
                    You pay nothing up front. Our share of the profit is reinvested into promoting the service in your city through your own marketing department, focusing on SMM.<br/>

                    If you’re interested in offering your guests something meaningful and unique — let’s talk!
                </span>
            </StyledWhy>
            <StyledWhy style={{textAlign:'center'}}>
                <h2>Contact:</h2>
                <p>Yury</p>
                <span>
                    <a href="https://www.instagram.com/yury.reut">
                        <InstagramIcon sx={{fontSize: 'xxx-large'}}/>
                    </a>
                </span>
            </StyledWhy>
        </div>
    );
};

export default WhyRest;
